import { css } from '@emotion/css';
``;
import { cn } from '@lyearn/style';

import { cardSizeMobileStyles, cardSizeStyles } from '../styles';

export const DISPLAY_CARD_SIZE = {
  default: {
    height: 27.6,
    width: 20.8,
  },
  mobile: {
    height: 24,
    width: 20.8,
  },
  legacy: {
    height: 42,
    width: 28,
  },
};

// Aspect ratio of the image is 18:14
export const DISPLAY_CARD_IMAGE_HEIGHT_MOBILE = 13;
export const DISPLAY_CARD_IMAGE_HEIGHT_WEB = 15.8;

export const displayCardImageHeight = (isMobile: boolean) => css`
  height: ${isMobile ? DISPLAY_CARD_IMAGE_HEIGHT_MOBILE : DISPLAY_CARD_IMAGE_HEIGHT_WEB}rem;
`;

// these styles are not used directly in the DISPLAYCARD, reason being we want responsive height and width on library page
export const displayCardSizeStyles = cn(
  cardSizeStyles(DISPLAY_CARD_SIZE.default),
  cardSizeMobileStyles(DISPLAY_CARD_SIZE.mobile),
);

export const DISPLAY_CARD_IMAGE_CONTAINER_STYLES = 'rounded-16 xs:rounded';
export const DISPLAY_CARD_IMAGE_CONTAINER_STYLES_FOR_DESKTOP =
  'group-hover:shadow-03 transform group-hover:-translate-y-4 transition-all duration-200';
